import { type QueryClient } from "@tanstack/react-query";
import { type LoaderFunctionArgs } from "react-router";

import { makeAuthenticatedHttpClient } from "@/shared/http/makeAuthenticatedHttpClient";

import { DatasetService } from "../DatasetService";

/**
 * The org that owns the `:datasetPath` route's dataset, for a route gate.
 * Fetches the record under the key `useDataset` reads, so the page reuses it.
 * `undefined` when the route names no dataset or the record cannot be fetched.
 */
export async function datasetOrgId(
  { params }: LoaderFunctionArgs,
  queryClient: QueryClient,
): Promise<string | undefined> {
  const datasetId = params.datasetPath;
  if (datasetId === undefined) {
    return undefined;
  }
  try {
    const dataset = await queryClient.fetchQuery({
      queryKey: ["datasetRecord", datasetId],
      queryFn: async ({ signal }) =>
        new DatasetService(await makeAuthenticatedHttpClient()).getDataset(
          datasetId,
          { abortSignal: signal },
        ),
      staleTime: 60000,
    });
    return dataset.org_id;
  } catch {
    return undefined;
  }
}
